import { Directive, TemplateRef } from '@angular/core';

export interface SelectionHandler {
  onNodeSelected: (id: string) => void;
  onNodeUnselected: (id: string) => void;
}
export interface OptionSelectNodeContext<T> {
  $implicit: T;
  selectionHandler: SelectionHandler;
}

@Directive({
  selector: '[optionSelectNode]',
})
export class OptionSelectNodeDirective<T> {
  constructor(readonly template: TemplateRef<OptionSelectNodeContext<T>>) {}
}
